import {
  isAfterDateUtil,
  subDaysDateUtil
} from 'packages/src'
import { getValueReduxUtil } from '@gymaholic/packages'

const TRENDING_DIFF_DAYS = 7

export default function isTrendingModelUtil (instance) {
  const trendingAt = getValueReduxUtil(instance, 'trendingAt')

  if (!trendingAt) {
    return false
  }

  return isAfterDateUtil(
    new Date(trendingAt),
    subDaysDateUtil(new Date(), TRENDING_DIFF_DAYS)
  )
}
